module.exports = __webpack_public_path__ + "img/banner-m.f8691f31.jpg";